import * as React from "react";

import { cn } from "@/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring aria-invalid:ring-destructive aria-invalid:border-destructive flex field-sizing-content min-h-20 w-full rounded-control border bg-card px-3 py-2 text-[1rem] transition-[color,box-shadow] duration-[var(--motion-fast)] ease-[var(--ease-standard)] outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-ui",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
